import React, { useEffect, useState, useRef, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { db } from '../..'
import { ref, set, onValue, push, update, get } from 'firebase/database'
import Loading from '../components/Loading'
import AddressLabel from '../components/AddressLabel'
import { Link, useNavigate } from 'react-router-dom'
import { SyncLoader } from 'react-spinners'
import { getStorage, ref as storageRef, uploadBytesResumable } from 'firebase/storage'
import ProgressBar from '@ramonak/react-progress-bar'
import BottomMenu from './components/BottomMenu'
import imageCompression from 'browser-image-compression'
import MissionSubmitStatus from './MissionSubmitStatus'
import QRCodeScanner from './components/QRCodeScanner'

const SubmitMission = () => {
    const location = useLocation();
    const { gameId, teamId, missionId } = location.state;
    const [mission, setMission] = useState({});
    const [loading, setLoading] = useState(true);
    const [position, setPosition] = useState({});
    const [comment, setComment] = useState('');
    const [teamData, setTeamData] = useState({});
    const navigate = useNavigate();
    const [loadingPosition, setLoadingPosition] = useState(false);
    const [image, setImage] = useState(null);
    const storage = getStorage();
    const [leftTime, setLeftTime] = useState(null);
    const timer = useRef(null);
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState(null);

    const [loadingImgs, setLoadingImgs] = useState([null, null, null]);
    const [totalLoding, setTotalLoading] = useState(null);
    const [teams, setTeams] = useState([]);
    const [qrCodeInput, setQrCodeInput] = useState('');
    const [showQrScanner, setShowQrScanner] = useState(false);
    const [resetTrigger, setResetTrigger] = useState(0);
    // const [urls, setUrls] = useState([null, null, null]);

    // 残り時間の計算
    const calcTimeLeft = useCallback((time) => {
        const now = new Date().getTime();
        const endTime = new Date(time).getTime();
        let timeLeft = endTime - now;

        if(timeLeft < 0) {
            timeLeft = 0;
            setDisabled(true);
        }

        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
    }, []);

    // タイマーの設定
    const setCalcTime = useCallback(async (deadline) => {
        await clearInterval(timer.current);
        timer.current = setInterval(() => {
            setLeftTime(calcTimeLeft(deadline));
        }, 1000);
    }, [calcTimeLeft]);

    useEffect(() => {
        // ミッション情報の取得
        const missionRef = ref(db, 'gameLogs/' + gameId + '/missions/' + missionId);

        const unsubscribeMission = onValue(missionRef, (snapshot) => {
            if(snapshot.exists()) {
                setMission(snapshot.val());

                // 残り時間の計算
                setCalcTime(snapshot.val().deadline);
            }
            setLoading(false);
        });

        //チームデータの取得
        const teamRef = ref(db, 'gameLogs/' + gameId + '/teams/' + teamId);
        const unsubscribeTeam = onValue(teamRef, (snapshot) => {
            if(snapshot.exists()) {
                setTeamData(snapshot.val());
            }
        });

        // 全チームデータの取得
        const teamsRef = ref(db, 'gameLogs/' + gameId + '/teams');
        get(teamsRef).then((snapshot) => {
            if(snapshot.exists()) {
                const teamsData = snapshot.val();
                const teamsArray = Object.keys(teamsData).map((key) => ({
                    id: key,
                    ...teamsData[key]
                }));
                setTeams(teamsArray);
            }
        });

        // ゲームステータスの取得
        const gameRef = ref(db, 'gameLogs/' + gameId + '/status');
        const unsubscribeStatus = onValue(gameRef, (snapshot) => {
            if(snapshot.exists()) {
                const status = snapshot.val().type;
                const finished = snapshot.val().finished;

                // 手動実行で、ゲーム進行中でない場合
                if(status === 0 || status === 4 || status === 5) {
                    setDisabled(true);
                    setError('ゲーム進行中ではないため、提出できません。');
                }

                // 自動実行で、ゲーム終了済みの場合
                if(status === 1 && finished === true) {
                    setDisabled(true);
                    setError('ゲームが終了しているため、提出できません。');
                }
            }
        });

        return () => {
            unsubscribeMission();
            unsubscribeTeam();
            unsubscribeStatus();
        };
    }, [gameId, missionId, teamId, setCalcTime]);

    // 提出権限を確認し、不可の場合は提出ボタンを無効化
    useEffect(() => {
        if(teamData && mission && mission.options) {
            if(Number(teamData.role) === 0 && mission.options[0] === true) {
                setDisabled(true);
                setError('逃走チームの提出が許可されていません。');
            }

            if(Number(teamData.role) === 1 && mission.options[1] === true) {
                setDisabled(true);
                setError('鬼チームの提出が許可されていません。');
            }
        }
    }, [teamData, mission]);
        

    // 位置情報取得
    const getPosition = () => {
        setLoadingPosition(true);

        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                setLoadingPosition(false);
                setPosition({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    speed: position.coords.speed,
                    accuracy: position.coords.accuracy
                });
            });
        }
    }

    // QRコード読み取り時のハンドラ
    const handleQRCodeRead = (qrCode) => {
        setQrCodeInput(qrCode);
        setShowQrScanner(false);
    };

    // 提出
    const submit = async (e) => {
        e.preventDefault();
        setDisabled(true);

        // 既に提出されている場合、エラーを表示
        if(mission.reports && mission.reports[teamId]) {
            setError('既に提出されています。');
            setDisabled(false);
            return;
        }

        // 何もデータがない場合、エラーを表示
        if(!position.lat && !comment && !image?.files && !qrCodeInput) {
            setError('位置情報・画像・コメント・QRコードのいずれかを入力してください。');
            setDisabled(false);
            return;
        }

        if(image && image.files) {
            setTotalLoading(0);

            await Promise.all(Object.keys(image.files).map(async (fileKey, index) => {
                await uploadCompressedImage(image.files[fileKey], index);
            }));
        } else {
            saveSubmitData();
        }
        
        return false;
    }

    // 提出データの保存
    const saveSubmitData = async (saveImage) => {
        // 既に提出されている場合、エラーを表示
        if(mission.reports && mission.reports[teamId]) {
            setError('既に提出されています。');
            setDisabled(false);
            return;
        }

        // console.log("saveImage", saveImage.files[0].name);
        const date = new Date();

        // データ作成
        const postData = {
            position: position,
            photo: saveImage ? Object.keys(image.files).map((fileKey) => image.files[fileKey].name) : null,
            comment: comment,
            qrCode: qrCodeInput || null,
            time: date.toISOString()
        }

        // 必須項目が入力されていない場合、エラーを表示
        if(mission.options[3] && !position.lat) {
            setError('位置情報が入力されていません。');
            setDisabled(false);
            return;
        }

        if(mission.options[4] && !saveImage) {
            setError('画像が入力されていません。');
            setDisabled(false);
            return;
        }

        if(mission.options[5] && !comment) {
            setError('コメントが入力されていません。');
            setDisabled(false);
            return;
        }

        if(mission.options[6] && !qrCodeInput) {
            setError('QRコードが入力されていません。');
            setDisabled(false);
            return;
        }

        if(mission.options[6] && mission.qrCode && qrCodeInput !== mission.qrCode) {
            setError('QRコードが正しくありません。');
            setDisabled(false);
            return;
        }

        // データ送信
        const reportsRef = ref(db, 'gameLogs/' + gameId + '/missions/' + missionId + '/reports/' + teamId);
        set(reportsRef, postData).then(() => {
            update(ref(db, 'gameLogs/' + gameId + '/teams/' + teamId), {
                score: Number(teamData.score) + Number(mission.score)
            })
            .then(() => {
                push(ref(db, "gameLogs/" + gameId + "/history"), {
                    action: 'ミッションの提出',
                    teamId: teamId,
                    missionId: missionId,
                    missionTitle: mission.name,
                    team: teamData,
                    report: postData,
                    actionNum: 4,
                    time: date.toISOString(),
                    addScore: Number(mission.score)
                }).then(() => {
                    //ローディングアニメーションの都合で遅延
                    setTimeout(() => {
                        navigate('/game/missions', { state: { gameId: gameId, teamId: teamId } });
                    }, 500);
                })
                .catch((error) => {
                    console.error('履歴追加エラー', error);
                    setError('履歴の追加に失敗しました。提出自体は完了していますが、履歴に表示されません。');
                    setDisabled(false);
                });
            })
            .catch((error) => {
                console.error('スコア更新エラー', error);
                setError('チームのスコアの更新に失敗しました。ゲーム運営者にお問い合わせください。');
                setDisabled(false);
            });
        }).catch((error) => {
            console.error('送信エラー', error);
            setError('送信エラーが発生しました。エラーが繰り返される場合は、ゲーム運営者にお問い合わせください。');
            setDisabled(false);
        });
    }

    // 画像の圧縮とアップロード
    const uploadCompressedImage = async (file, index) => {
        const options = {
          maxSizeMB: 1, // 最大1MB
          maxWidthOrHeight: 1200, // 最大幅・高さ1200px
          useWebWorker: true,
        };
      
        try {
          const compressedFile = await imageCompression(file, options);
          
          const photoRef = storageRef(storage, 'gameLogs/' + gameId + '/missions/' + missionId + '/reports/' + teamId + '/' + compressedFile.name);
          const task = uploadBytesResumable(photoRef, compressedFile);
      
          task.on('state_changed', (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

            // 進捗状況を保存
            setLoadingImgs((prev) => {
                const newImgs = [...prev];
                newImgs[index] = Number(progress);
                return newImgs;
            });
          }, (error) => {
            console.error('アップロードエラー:', error);
            setError('画像のアップロードに失敗しました。');
            setDisabled(false);
          });
        //   }, async () => {
        //     const downloadURL = await getDownloadURL(task.snapshot.ref);
        //     console.log('File available at', downloadURL);
        //   });
        } catch (error) {
          console.error("画像圧縮エラー:", error);
        }
    };

    //画像の進捗状況を監視
    useEffect(() => {
        if(loadingImgs.find((v) => v !== null)) {
            // console.log(Number(loadingImgs.reduce((a, b) => a + b)) / Number(loadingImgs.filter((v) => v !== null).length));
            setTotalLoading((prev) => Math.floor(Number(loadingImgs.reduce((a, b) => a + b)) / Number(loadingImgs.filter((v) => v !== null).length)));
        }
    }, [loadingImgs]);

    //画像の変更
    const onImgChange = (e) => {
        // いずれかの画像の撮影時刻がミッション開始前ならエラーを表示
        if(e.target.files) {
            const startTime = new Date(mission.startTime).getTime();
            let flag = false;

            for(let i = 0; i < e.target.files.length; i++) {
                if(new Date(e.target.files[i].lastModified).getTime() < startTime) {
                    setError('ミッション開始前の画像は提出できません。');
                    setDisabled(true);
                    flag = true;
                    return;
                }
            }

            // エラーがなければ、エラーメッセージを消す
            if(!flag) {
                setError(null);
                setDisabled(false);
            }
        }

        if(e.target.files.length > 3) {
            alert('3枚までの画像を選択してください。');
            document.getElementById("missionImg").value = null;
            setImage(null);

            return;
        } else {
            setImage(e.target);
        }
    }

    //画像のアップロードが完了したらデータを送信
    // saveSubmitDataは多数の状態（position/comment/qrCodeInput/mission/teamData等）に依存する提出処理のため、
    // 依存配列にそのまま加えると関数の再生成のたびに二重送信されてしまう危険がある。
    // このeffectはtotalLoding（アップロード進捗）が100に達したときのみ発火させる意図的な設計とする。
    useEffect(() => {
        if(totalLoding === 100) {
            saveSubmitData(image);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalLoding, image]);

    return (
        <div className='max-w-6xl mx-auto my-6'>
            <Loading show={loading} text="ミッションを読込み中…" />

            <h1 className='text-2xl mb-6 mx-4 text-center'>ミッション</h1>

            <div className='lg:grid lg:grid-cols-2'>
                {/* ミッション情報 */}
                <div className='rounded-lg border bg-white p-4 m-3 mb-6'>
                    <h2 className='text-lg mb-2 text-purple-600'>ミッション情報</h2>

                    {/* タイトル */}
                    <div className='mb-5 ms-3'>
                        <h3 className='text-xl border-b-8 border-lime-300/50 inline px-2 text-gray-800'>{mission && mission.name}</h3>
                    </div>

                    {/* 詳細 */}
                    <div className='mb-8 ms-3'>
                        <p className='text-base text-gray-600 whitespace-pre-wrap'>{mission && mission.detail}</p>
                    </div>

                    {/* ミッション画像 */}
                    {mission && mission.image && (
                        <div className='mb-5 ms-3'>
                            <img src={mission.image} alt="ミッション画像" className='rounded-lg shadow-md max-w-full' />
                        </div>
                    )}

                    <div className='mb-3 ms-3 grid grid-cols-2 gap-5'>
                        <div>
                            <h4 className='text-base text-gray-600'><i className='bi bi-coin me-1 text-lime-600'></i>報酬スコア</h4>
                            <div className='text-xl text-gray-800 ms-2'>{mission && mission.score} pt</div>
                        </div>

                        <div>
                            <h4 className='text-base text-gray-600'><i className='bi bi-x-lg me-1 text-lime-600'></i>未達成時の減点</h4>
                            <div className='text-xl text-gray-800 ms-2'>{mission && mission.penalty} pt</div>
                        </div>

                        <div>
                            <h4 className='text-base text-gray-600 mb-1'><i className='bi bi-key me-1 text-lime-600'></i>提出権限</h4>
                            <div className='text-base text-gray-800 ms-2'>{mission.options && (!mission.options[0] && '🏃‍♂️‍➡️逃走 ')}{mission.options && (!mission.options[1] && '👹鬼')}</div>
                        </div>

                        <div>
                            <h4 className='text-base text-gray-600 mb-1'><i className='bi bi-folder me-1 text-lime-600'></i>必須項目</h4>

                            
                            {mission.options && (
                                <div className='flex gap-2 items-center ms-2'>
                                    {mission.options[3] && (
                                        <div className='text-sm text-gray-800 bg-gray-100 p-1 rounded-md'><i className='bi bi-pin-map mx-1'></i>位置情報</div>
                                    )}

                                    {mission.options[4] && (
                                        <div className='text-sm text-gray-800 bg-gray-100 p-1 rounded-md'><i className='bi bi-camera mx-1'></i>写真</div>
                                    )}

                                    {mission.options[5] && (
                                        <div className='text-sm text-gray-800 bg-gray-100 p-1 rounded-md'><i className='bi bi-chat-dots mx-1'></i>コメント</div>
                                    )}

                                    {mission.options[6] && (
                                        <div className='text-sm text-gray-800 bg-gray-100 p-1 rounded-md'><i className='bi bi-qr-code mx-1'></i>QRコード</div>
                                    )}
                                </div>
                            )}
                            
                        </div>

                        <div>
                            <h4 className='text-base text-gray-600'><i className='bi bi-clock me-1 text-lime-600'></i>残り時間</h4>
                            <div className='text-2xl text-gray-800 ms-2 play-regular'>{leftTime !== null ? leftTime : "--:--:--"}</div>
                            <div className='text-base text-lime-700 ms-2 play-regular'>{mission && new Date(mission.deadline).toLocaleTimeString()} まで</div>
                        </div>
                    </div>
                </div>

                {/* 提出フォーム */}
                <div className='rounded-lg border bg-white p-4 m-3 mb-6'>
                    <h2 className='text-lg mb-2 text-purple-600'><i className='bi bi-upload me-2'></i>提出</h2>

                    <form onSubmit={(e) => {submit(e)}}>
                        <label className='block mb-6'>
                            <span className='text-gray-600'>位置情報</span>
                            <div className='relative rounded-lg border border-gray-300 min-h-28 cursor-pointer'>
                                <div className='p-2 pb-0 pe-24'>
                                    {position.lat ? (
                                        <div className='text-gray-800'>
                                            <div><AddressLabel lat={position.lat} lng={position.lng} /></div>
                                            <Link target='_blank' to={"https://maps.google.com/maps?ll=" + position.lat + "," + position.lng} className='inline-block rounded-md border shadow-sm py-1 px-2 m-1 my-2 hover:bg-gray-50 text-gray-600'><i className='bi bi-map me-2'></i>マップで確認</Link>
                                        </div>
                                    ) : (
                                        <div className='text-gray-500'>取得していません</div>
                                    )}
                                    
                                    {loadingPosition && (
                                        <div className='m-3 text-center'><SyncLoader color="#c084fc" size={12} /></div>
                                    )}

                                </div>
                                <button className='absolute end-2 top-2 bg-purple-500 hover:bg-purple-600 text-white p-4 rounded-lg block shadow-sm' type="button" onClick={() => getPosition()}>
                                    <div className='mb-1'><i className='bi bi-geo-alt me-2 text-3xl'></i></div>
                                    <div className='text-sm'>取得する</div>
                                </button>
                            </div>
                            
                        </label>

                        <label className='block mb-6'>
                            <span className='text-gray-600'>写真</span>
                            <input type='file' id="missionImg" onChange={(e) => onImgChange(e)} className='block w-full p-2 border border-gray-300 rounded-lg focus:outline-purple-300' accept="image/*" multiple capture="environment" />
                        </label>

                        <label className='block mb-6'>
                            <span className='text-gray-600'>コメント</span>
                            <textarea value={comment} onChange={(e) => setComment(e.target.value)} className='block w-full p-2 border border-gray-300 rounded-lg focus:outline-purple-300'></textarea>
                        </label>

                        {/* QRコード入力フィールド */}
                        {mission.options && mission.options[6] && (
                            <label className='block mb-6'>
                                <span className='text-gray-600'>QRコード</span>
                                <div className='relative rounded-lg border border-gray-300 min-h-28'>
                                    <div className='p-2 pb-0' onClick={(e) => e.stopPropagation()}>
                                        {qrCodeInput ? (
                                            <div className='text-gray-800 pr-24 relative'>
                                                <input 
                                                    value={qrCodeInput} 
                                                    onChange={(e) => setQrCodeInput(e.target.value)} 
                                                    type='text' 
                                                    className='w-full bg-transparent border-none outline-none text-gray-800 text-base cursor-text pr-6'
                                                    placeholder='QRコードの内容が表示されます'
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                            </div>
                                        ) : (
                                            <input 
                                                value={qrCodeInput} 
                                                onChange={(e) => setQrCodeInput(e.target.value)} 
                                                type='text' 
                                                className='w-full bg-transparent border-none outline-none text-gray-500 text-base cursor-text pr-24'
                                                placeholder='QRコードをスキャンまたは手動入力'
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        )}
                                    </div>
                                    <button 
                                        type='button'
                                        className={`absolute end-2 top-2 text-white p-4 rounded-lg block shadow-sm transition-all duration-200 ${
                                            qrCodeInput 
                                                ? 'bg-gray-400 cursor-not-allowed' 
                                                : 'bg-purple-500 hover:bg-purple-600 cursor-pointer'
                                        }`}
                                        onClick={() => {
                                            if (qrCodeInput) return; // QRコードが入力済みの場合は何もしない
                                            
                                            if (showQrScanner) {
                                                setShowQrScanner(false);
                                            } else {
                                                // 再度開いたときに直前のスキャン結果をリセットし、同じQRコードも再スキャンできるようにする
                                                setResetTrigger((prev) => prev + 1);
                                                setShowQrScanner(true);
                                            }
                                        }}
                                        disabled={!!qrCodeInput} // QRコードが入力済みの場合は無効化
                                    >
                                        <div className='mb-1'>
                                            <i className={`text-2xl ${
                                                qrCodeInput 
                                                    ? 'bi bi-check-circle-fill' 
                                                    : showQrScanner 
                                                        ? 'bi bi-stop-fill' 
                                                        : 'bi bi-qr-code-scan'
                                            }`}></i>
                                        </div>
                                        <div className='text-sm'>
                                            {qrCodeInput 
                                                ? '読取完了' 
                                                : showQrScanner 
                                                    ? '停止' 
                                                    : 'スキャン'
                                            }
                                        </div>
                                    </button>
                                </div>
                                
                                {/* QRコードスキャナーコンポーネント */}
                                <QRCodeScanner 
                                    onQRCodeRead={handleQRCodeRead}
                                    isVisible={showQrScanner}
                                    onClose={() => setShowQrScanner(false)}
                                    resetTrigger={resetTrigger}
                                />
                            </label>
                        )}

                        <button type='submit' className={'relative block w-full text-white p-2 rounded-lg shadow-sm text-lg ' + (disabled ? 'bg-purple-300' : 'bg-purple-500 hover:bg-purple-600')} disabled={totalLoding !== null || disabled}>
                            <i className='bi bi-send me-2'></i>提出
                        </button>

                        {totalLoding !== null && (
                            <div className='my-4 mx-3'>
                                <label>写真の送信中…</label>
                                <ProgressBar completed={totalLoding} height="24px" maxCompleted={100} />
                            </div>
                        )}

                        {error && (
                            <div className='text-red-600 mt-4'>{error}</div>
                        )}
                    </form>
                </div>

                {/* 提出状況 */}
                <MissionSubmitStatus mission={mission} teams={teams} />
            </div>

            {/* 下部固定メニュー */}
            <BottomMenu gameId={gameId} teamId={teamId} />
        </div>
    )
}

export default SubmitMission